// logProcessors.js

/**
 * Форматирует сообщение StatusNotification с stations
 */
function formatStatusNotification(data) {
  const { stations } = data;
  if (!stations || typeof stations !== "object") {
    return JSON.stringify(["StatusNotification", data], null, 2);
  }

  let str = '[\n  "StatusNotification",\n  {\n    "stations": {';
  const keys = Object.keys(stations);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const val = stations[key];
    str += `\n      "${key}": [${Array.isArray(val) ? val.join(",") : JSON.stringify(val)}]`;
    if (i < keys.length - 1) str += ",";
  }
  str += "\n    }\n  }\n]";
  return str;
}

/**
 * Форматирует ChangeConfiguration
 */
function formatChangeConfiguration(letter, data) {
  // Проверяем, что data — объект
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    return JSON.stringify(["ChangeConfiguration", letter, data], null, 2);
  }

  let str = `[\n  "ChangeConfiguration",\n  "${letter}",\n  {`;
  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const val = data[key];
    const valStr = typeof val === "string" ? `"${val}"` : String(val);
    str += `\n    "${key}": ${valStr}`;
    if (i < keys.length - 1) str += ",";
  }
  str += "\n  }\n]";
  return str;
}

/**
 * Форматирует mismatch
 */
function formatMismatch(data) {
  if (typeof data !== "object" || data === null) {
    return JSON.stringify(["mismatch", data], null, 2);
  }

  let result = '[\n  "mismatch",\n  {';

  const parts = [];

  // meters
  if (data.meters) {
    const m = data.meters;
    const dbStr = Array.isArray(m.db)
      ? `[${m.db.join(",")}]`
      : JSON.stringify(m.db);
    const deviceStr = Array.isArray(m.device)
      ? `[${m.device.join(",")}]`
      : JSON.stringify(m.device);
    const matchStr = String(m.match);
    parts.push(
      `\n    "meters": {\n      "db": ${dbStr},\n      "match": ${matchStr},\n      "device": ${deviceStr}\n    }`,
    );
  }

  // params
  if (data.params) {
    const p = data.params;
    const paramEntries = [];
    for (const key of ["tt", "buffer", "limit_line", "limit_module"]) {
      if (p[key]) {
        const item = p[key];
        const dbVal = item.db ?? "null";
        const matchVal = String(item.match);
        const deviceVal = item.device ?? "null";
        paramEntries.push(
          `\n      "${key}": {\n        "db": ${dbVal},\n        "match": ${matchVal},\n        "device": ${deviceVal}\n      }`,
        );
      }
    }
    if (paramEntries.length > 0) {
      parts.push(`\n    "params": {${paramEntries.join(",")}\n    }`);
    }
  }

  // stations
  if (data.stations) {
    const s = data.stations;
    const dbStr = typeof s.db === "string" ? `"${s.db}"` : JSON.stringify(s.db);
    const deviceStr =
      typeof s.device === "string" ? `"${s.device}"` : JSON.stringify(s.device);
    const matchStr = String(s.match);
    parts.push(
      `\n    "stations": {\n      "db": ${dbStr},\n      "match": ${matchStr},\n      "device": ${deviceStr}\n    }`,
    );
  }

  result += parts.join(",");
  result += "\n  }\n]";
  return result;
}

/**
 * Основная функция обработки
 */
export const processLogMessage = (message) => {
  if (!Array.isArray(message) || message.length === 0) {
    return JSON.stringify(message, null, 2);
  }

  const [type] = message;

  if (
    type === "StatusNotification" &&
    message.length === 2 &&
    typeof message[1] === "object"
  ) {
    return formatStatusNotification(message[1]);
  }

  if (
    type === "ChangeConfiguration" &&
    message.length === 3 &&
    typeof message[1] === "string" &&
    typeof message[2] === "object"
  ) {
    return formatChangeConfiguration(message[1], message[2]);
  }

  if (
    type === "mismatch" &&
    message.length === 2 &&
    typeof message[1] === "object"
  ) {
    return formatMismatch(message[1]);
  }

  // Любое другое сообщение — оставляем как есть
  return JSON.stringify(message, null, 2);
};
